"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeHex = exports.padLeftEven = exports.getSignTransactionObject = exports.getHexTxObject = exports.getBufferFromHex = exports.calculateChainIdFromV = exports.bufferToHex = void 0;

var _ethereumjsUtil = require("ethereumjs-util");

var getBufferFromHex = function getBufferFromHex(hex) {
  hex = sanitizeHex(hex);

  var _hex = hex.toLowerCase().replace('0x', '');

  return new Buffer(_hex, 'hex');
};

exports.getBufferFromHex = getBufferFromHex;

var padLeftEven = function padLeftEven(hex) {
  hex = hex.length % 2 != 0 ? '0' + hex : hex;
  return hex;
};

exports.padLeftEven = padLeftEven;

var sanitizeHex = function sanitizeHex(hex) {
  hex = hex.substring(0, 2) == '0x' ? hex.substring(2) : hex;
  if (hex == '') return '';
  return '0x' + padLeftEven(hex);
};

exports.sanitizeHex = sanitizeHex;

var bufferToHex = function bufferToHex(buffer) {
  return '0x' + buffer.toString('hex');
};

exports.bufferToHex = bufferToHex;

var getHexTxObject = function getHexTxObject(tx) {
  return {
    to: sanitizeHex(tx.to.toString('hex')),
    value: sanitizeHex(tx.value.toString('hex')),
    data: sanitizeHex(tx.data.toString('hex')),
    chainId: tx.getChainId(),
    nonce: sanitizeHex(tx.nonce.toString('hex')),
    gasLimit: sanitizeHex(tx.gasLimit.toString('hex')),
    gasPrice: sanitizeHex(tx.gasPrice.toString('hex'))
  };
};

exports.getHexTxObject = getHexTxObject;

var getSignTransactionObject = function getSignTransactionObject(tx) {
  return {
    rawTransaction: bufferToHex(tx.serialize()),
    tx: {
      nonce: bufferToHex(tx.nonce),
      gasPrice: bufferToHex(tx.gasPrice),
      gas: tx.gasLimit ? bufferToHex(tx.gasLimit) : bufferToHex(tx.gas),
      to: bufferToHex(tx.to),
      value: bufferToHex(tx.value),
      input: bufferToHex(tx.data),
      v: bufferToHex(tx.v),
      r: bufferToHex(tx.r),
      s: bufferToHex(tx.s),
      hash: bufferToHex(tx.hash())
    }
  };
};

exports.getSignTransactionObject = getSignTransactionObject;

var calculateChainIdFromV = function calculateChainIdFromV(v) {
  var sigV = (0, _ethereumjsUtil.bufferToInt)(v);
  var chainId = Math.floor((sigV - 35) / 2);
  if (chainId < 0) chainId = 0;
  return chainId;
};

exports.calculateChainIdFromV = calculateChainIdFromV;